<template>
  <div class="py-2 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- Card header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">Acessos de Implantadores às Empresas</h5>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto">
                  <router-link :to="{ name: 'Implantador Acesso Empresa', params: { id: 'new' } }">
                    <button class="mt-1 mb-0 me-2 btn btn-outline-success btn-sm mt-sm-0" type="button" name="button">
                      <i class="fas fa-plus"></i>
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="p-3 card-body">
            <DataTable :items="getData" :columns="columns" :pagination="pagination" :loading="loading"
              :search-value="search" :search-label="'Pesquisar'" :search-placeholder="'ID, Nome Fantasia, CNPJ, Cidade'"
              :empty-message="'Nenhum acesso disponível ou filtro não retornou resultados'" @search="onSearchChanged"
              @page-change="mudarPagina" text-size-class="text-md">
              <template #dataInicio="{ item }">
                {{ filters.formatDate(item.dataInicio) }}
              </template>
              <template #dataFim="{ item }">
                {{ filters.formatDate(item.dataFim) }}
              </template>
              <template #tipoAcesso="{ item }">
                <BadgeTipoAcesso :tipo-acesso="item.tipoAcesso" size="md" />
              </template>
              <template #status="{ item }">
                <BadgeStatusAcesso :status="item.status" size="md" />
              </template>
              <template #actions="{ item }">
                <button type="button" class="btn btn-xs btn-primary px-3 me-2" @click="editarAcesso(item)"
                  v-if="item.status == 1">
                  Editar
                </button>
                <button type="button" class="btn btn-xs btn-warning px-3 mb-0 text-dark"
                  @click="cancelarAgendamento(item)" v-if="item.status == 1">
                  Cancelar agendamento
                </button>
                <button type="button" class="btn btn-xs btn-danger px-3 mb-0" @click="cancelarAcesso(item)"
                  v-if="item.status == 2">
                  Remover acesso
                </button>
                <span class="badge badge-sm bg-dark" v-if="![1, 2].includes(item.status)">
                  Nenhuma ação disponível
                </span>
              </template>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';
import DataTable from '@/components/DataTable.vue';
import debounce from 'lodash/debounce';
import { showConfirm, successToast, errorToast } from '@/utils/alerts';
import BadgeStatusAcesso from './components/BadgeStatusAcesso.vue';
import BadgeTipoAcesso from './components/BadgeTipoAcesso.vue';

export default {
  name: "ImplantadoresAcessoEmpresas",
  components: {
    DataTable,
    BadgeStatusAcesso,
    BadgeTipoAcesso,
  },
  data() {
    return {
      implantadores: [],
      loading: false,
      search: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      totalPages: 0,
      orderBy: 'id',
      orderDirection: 'DESC',
      columns: [
        { key: 'id', label: 'ID' },
        { key: 'implantadorNome', label: 'Implantador' },
        { key: 'usuarioNome', label: 'Usuário' },
        { key: 'empresaId', label: 'Empresa' },
        { key: 'dataInicio', label: 'Data Início' },
        { key: 'dataFim', label: 'Data Fim' },
        { key: 'status', label: 'Status' },
        { key: 'tipoAcesso', label: 'Tipo de Acesso' },
        { key: 'actions', label: 'Ações', headerClass: 'text-center', class: 'text-center' }
      ]
    }
  },
  created() {
    this.fetchData();
    this.debouncedBuscar = debounce(this.fetchData, 300);
  },
  methods: {
    fetchData() {
      this.loading = true;

      const params = {
        page: this.currentPage,
        limit: this.pageSize,
        search: this.search,
        orderBy: this.orderBy,
        orderDirection: this.orderDirection
      };

      api.get('/implantadores-acesso-empresas', { params })
        .then(({ data }) => {
          this.implantadores = data.items;
          this.total = data.total;
          this.totalPages = data.totalPages;
          this.loading = false;
        })
        .catch(error => {
          console.error('Erro ao buscar empresas:', error);
          this.loading = false;
        });
    },
    resetarFiltros() {
      this.search = '';
      this.currentPage = 1;
      this.orderBy = 'id';
      this.orderDirection = 'DESC';
    },
    // Método chamado quando o input de busca muda
    onSearchChanged(value) {
      this.search = value;
      this.currentPage = 1; // Voltar para a primeira página ao buscar
      this.debouncedBuscar();
    },
    // Mudar de página
    mudarPagina(pagina) {
      if (pagina < 1 || pagina > this.totalPages || pagina === this.currentPage) {
        return;
      }

      this.currentPage = pagina;
      this.fetchData();
    },
    async cancelarAcesso(item) {
      const confirm = await showConfirm(`Tem certeza que deseja remover o acesso de ${item.implantadorNome} à empresa ${item.empresaId}?`);

      if (!confirm) {
        return;
      }

      try {
        await api.delete(`/implantadores-acesso-empresas/${item.id}/remove-access`);
        this.fetchData();
        successToast('Acesso removido com sucesso!');
      } catch (error) {
        console.error('Erro ao remover acesso:', error);
        errorToast(error.data.message ?? 'Erro ao remover acesso');
      }
    },
    async cancelarAgendamento(item) {
      const confirm = await showConfirm(`Tem certeza que deseja cancelar o agendamento de ${item.implantadorNome} à empresa ${item.empresaId}?`);

      if (!confirm) {
        return;
      }
      try {
        await api.delete(`/implantadores-acesso-empresas/${item.id}/cancel-access`)
        this.fetchData();
        successToast('Agendamento cancelado com sucesso!');
      } catch (e) {
        errorToast(e.data.message ?? 'Erro ao cancelar agendamento');
      }
    },
    editarAcesso(item) {
      this.$router.push({ name: 'Implantador Acesso Empresa', params: { id: item.id } });
    }
  },
  computed: {
    getData() {
      return this.implantadores;
    },
    // Objeto de paginação para o DataTable
    pagination() {
      return {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        total: this.total,
        totalPages: this.totalPages,
        hasPreviousPage: this.currentPage > 1,
        hasNextPage: this.currentPage < this.totalPages
      };
    },
  }
};
</script>